import axios from 'axios';
import Swal from 'sweetalert2';
// const API_BASE_URL = "http://localhost:8001/api/user";

// Get user by ID
export const getUserById = async (userId) => {
  try {
    const response = await axios.get(`/user/new/${userId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch user details");
  }
};



  
const isValidEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
};

// Function to validate phone number format
const isValidPhoneNumber = (phone) => {
    const phonePattern = /^\+?[0-9]{10,15}$/; // Adjust regex based on your phone number format
    return phonePattern.test(phone);
};

export const updateUser = async (userId, formData) => {
    // Check if the email is valid
    if (formData.email && !isValidEmail(formData.email)) {
        Swal.fire({
            title: 'Invalid Email!',
            text: 'Please enter a valid email address.',
            icon: 'error',
            confirmButtonText: 'OK'
        });
        return; // Exit the function if the email is invalid
    }

    // Check if the phone number is valid
    if (formData.phone && !isValidPhoneNumber(formData.phone)) {
        Swal.fire({
            title: 'Invalid Phone Number!',
            text: 'Please enter a valid phone number.',
            icon: 'error',
            confirmButtonText: 'OK'
        });
        return; // Exit the function if the phone number is invalid
    }

    try {
        const response = await axios.put(`/user/update/${userId}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      
        
        console.log('User updated successfully:', response.data);

        // Success alert removed to prevent duplicate notifications

        return response.data; 
    } catch (error) {
        console.error('Error updating user:', error.message);
        throw error; // Re-throw error so caller can handle it
    }
};



export const fetchAllUsers = async () => {
  try {
    const response = await axios.get("/user/getAllUsers"); // Replace with your actual API endpoint
    if (response.data.success) {
      console.log("Users:", response.data.data);
      return response.data.data; // Return the user data if needed
    } else {
      console.error("Failed to fetch users:", response.data.message);
      return [];
    }
  } catch (error) {
    console.error("Error during API call:", error);
    return [];
  }
};

export const fetchUserById = async (userId) => {
    try {
      const response = await axios.get(`/user/new/${userId}`); 
      if (response.data.success) {
        return response.data.data; 
      } else {
        throw new Error(response.data.message || "Failed to fetch user.");
      }
    } catch (error) {
      console.error("Error fetching user by ID:", error.message);
      throw error; 
    }
  };

  export const updateUserById = async (userId, formData) => {
    return await axios.put(`/user/${userId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };

  export const changePassword = async (passwordData) => {
    try {
      const response = await axios.put(`/user/changePassword`, passwordData);
      
      if (response.data) {
        await Swal.fire({
          title: 'Success!',
          text: 'Password changed successfully',
          icon: 'success',
          confirmButtonText: 'OK'
        });
        return response.data;
      }
    } catch (error) {
      let errorMessage = "Failed to change password";
      
      if (error.response) {
        switch (error.response.status) {
          case 401:
            errorMessage = "Current password is incorrect";
            break;
          case 404:
            errorMessage = "User not found. Please log in again";
            break;
          case 400:
            errorMessage = error.response.data?.message || "Invalid password data";
            break;
          case 500:
            errorMessage = "Server error. Please try again later";
            break;
          default:
            errorMessage = error.response.data?.message || "Failed to change password";
        }
      }
  
      await Swal.fire({
        title: 'Error!',
        text: errorMessage,
        icon: 'error',
        confirmButtonText: 'OK'
      });
      throw new Error(errorMessage);
    }
  };

  export const forgotPassword = async (user_name, email) => {
  try {
    const response = await axios.post(`/user/forgetPassword`, {
      user_name,
      email,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "An error occurred" };
  }
};

export const toggleLoginAccess = async (userId, enable, reason, performedBy, performedByName) => {
  try {
    const response = await axios.put(`/user/toggle-login-access/${userId}`, {
      enable,
      reason,
      performedBy,
      performedByName,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to toggle login access" };
  }
};

export const getLoginAccessHistory = async (userId) => {
  try {
    const response = await axios.get(`/user/login-access-history/${userId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to fetch login access history" };
  }
};